var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_1552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55 8C6.55 7.07174 6.90821 6.1815 7.54584 5.52513C8.18346 4.86875 9.04826 4.5 9.95 4.5C10.8517 4.5 11.7165 4.86875 12.3542 5.52513C12.9918 6.1815 13.35 7.07174 13.35 8C13.35 8.92826 12.9918 9.8185 12.3542 10.4749C11.7165 11.1313 10.8517 11.5 9.95 11.5C9.04826 11.5 8.18346 11.1313 7.54584 10.4749C6.90821 9.8185 6.55 8.92826 6.55 8ZM4 17.6879C4 14.9945 6.11969 12.8125 8.73609 12.8125H11.1639C13.7803 12.8125 15.9 14.9945 15.9 17.6879C15.9 18.1363 15.5467 18.5 15.1111 18.5H4.78891C4.35328 18.5 4 18.1363 4 17.6879ZM20.1845 18.5H16.5242C16.6677 18.243 16.7527 17.9449 16.7527 17.625V17.4062C16.7527 15.7465 16.0328 14.2563 14.8986 13.2555C14.9623 13.2527 15.0234 13.25 15.0872 13.25H16.7181C19.0822 13.25 21 15.2242 21 17.6605C21 18.1254 20.6334 18.5 20.1845 18.5ZM15.475 11.5C14.6516 11.5 13.9078 11.1555 13.3686 10.6004C13.8919 9.87305 14.2 8.97344 14.2 8C14.2 7.26719 14.0247 6.57539 13.7139 5.96836C14.208 5.59648 14.8162 5.375 15.475 5.375C17.1192 5.375 18.45 6.74492 18.45 8.4375C18.45 10.1301 17.1192 11.5 15.475 11.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_1552"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.bd89335f20dee7812ae69de8b1d574e5.svg";
export { ForwardRef as ReactComponent };